// extracted by mini-css-extract-plugin
export var table = "_xi-0";